module.exports = __webpack_public_path__ + "img/40_38_040_160.c6a24011.jpg";